import { AfterViewInit, Component, Input } from "@angular/core";
import { INSIGHTS_FIELD, Linqset, NODE_SUPERTYPE, NODE_TYPE } from "../common/linqset-model";
import { InsightsFieldType } from "../insights/model/insights-field-type";
import { NODE_TYPE_DATA_TYPE, NodeTypeData } from "../insights/node-types/node-type-data";
import { NodeService } from "../model-services/node.service";
import { MODEL_COLOURS } from "../model-services/model-item-enums";

@Component({
    selector: 'app-insights-overlay',
    templateUrl: './insights-overlay.html',
    styleUrls: ['./insights-overlay.scss'],
    standalone: false
})
export class InsightsOverlayComponent implements AfterViewInit {
    @Input() linqset:Linqset

    step:number = 0
    messages:string[] = [
        "Quickly gain insights about time, cost, capacity, carbon and value",
        "View time and costs of each action",
        "View breakdown of costs for each action"
    ]
    fieldType:InsightsFieldType
    typeData:NodeTypeData

    constructor(private nodeService:NodeService) {

    }

    ngAfterViewInit(): void {
        this.fieldType = new InsightsFieldType(INSIGHTS_FIELD.COST, this.linqset.modelKey, this.linqset.workspaceKey)
        const typeInfo = this.nodeService.getNodeTypeForSuperType(NODE_SUPERTYPE.ACTION)
        const list = this.linqset.nodes.filter(n => !n.excluded && n.superType === NODE_SUPERTYPE.ACTION)
        
        this.typeData = new NodeTypeData(typeInfo.name, NODE_TYPE_DATA_TYPE.STANDARD, MODEL_COLOURS.ACTION_COLOR, MODEL_COLOURS.ACTION_HOVER_COLOR, NODE_SUPERTYPE.ACTION, NODE_TYPE.ACTION)
        this.typeData.list = list.sort((a,b) => a.name?.toLowerCase() > b.name?.toLowerCase()?1:0)
        this.step = 0
        this.nextStep()
    }

    nextStep() {
        if (this.step >= 2) return
        setTimeout(() => {
            this.step++
            this.nextStep()
        }, 9000)
    }
}
